import { axios } from '@/utils/request'
// eslint-disable-next-line
// import { BasicLayout, BlankLayout, PageView, RouteView } from '@/layouts'
import { Menu } from '@/api/dto/admin/Menu'
import api from '@/api/index'
import store from '@/store'
import Vue from 'vue'
import { MENU_PARAM_LIST } from '@/store/mutation-types'
import { constantRouterComponents } from '@/config/router.config'
import i18n from '@/locales'

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
    path: '*', redirect: '/404', hidden: true
}

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export const getRouterByUser = (user) => {
    return axios({
        url: api.JsonGet,
        method: 'post',
        data: {
            'Menus[]': {
                'Employee_Menus': {
                    'Employee_id@': user.id
                },
                'Menu': {
                    'id@': 'Menus[]/Employee_Menus/MENU_ID',
                    'Query': {
                        'id@': 'Menus[]/Menu/QUERY_ID'
                    }
                }
            }
        },
        headers: {
            'Content-Type': 'application/json'
        }
        /* headers: {
          'Access-Token': 'xxx'
        }
        */
    })
}

/**
 * 获取路由菜单信息
 *
 * 1. 调用 getRouterByUser() 访问后端接口获得路由结构数组
 *    @see https://github.com/sendya/ant-design-pro-vue/blob/feature/dynamic-menu/public/dynamic-menu.json
 * 2. 调用
 * @returns {Promise<any>}
 */

export function generatorDynamicRouter(employee) {
    const parent = menuTreeGenerator(employee.operator.menus.filter(m => m.available), [])
    const routers = generator(parent, null)
    routers.push(notFoundRouter)
    return routers
}

/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (function gen(routerMap, parent) {
    return routerMap.map(item => {
        //获取路由参数  add by mcp 2020-1-20
        let menuParams = Vue.ls.get(MENU_PARAM_LIST)
        if (!menuParams || Object.keys(menuParams).length === 0) {
            menuParams = store.getters.menuParams
        }
        const pa = menuParams.find(param => param.key === item.key)
        let queryParam = null
        if (pa) {
            queryParam = pa
        }
        const currentRouter = {
            // 路由地址 动态拼接生成如 /dashboard/workplace
            path: `${parent && parent.path || ''}/${item.key}`,
            // 路由名称，建议唯一
            name: item.name || item.key || '',
            // 该路由对应页面的 组件
            component: constantRouterComponents[item.component || item.key],
            hidden: typeof item.hidden === 'undefined' ? false : item.hidden,
            hideChildrenInMenu: item.hideChildrenInMenu === 'undefined' ? false : item.hideChildrenInMenu,
            // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
            meta: {
                title: item.meta ? i18n.t(item.meta.title) : undefined,
                icon: item.meta ? item.meta.icon : undefined,
                permission: item.key && [item.key] || null,
                keepAlive: item.meta ? (item.meta.keepAlive === undefined ? true : item.meta.keepAlive) : true,
                hiddenHeaderContent: item.meta ? (item.meta.hiddenHeaderContent === undefined ? true : item.meta.hiddenHeaderContent) : true
            },
            //meta:item.meta,
            props: {
                queryParam: queryParam
            }
        }

        // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
        currentRouter.path = currentRouter.path.replace('//', '/')
        // 重定向
        item.redirect && (currentRouter.redirect = item.redirect)
        // 是否有子菜单，并递归处理
        if (item.children && item.children.length > 0) {
            // Recursion
            currentRouter.children = gen(item.children, currentRouter)
        }
        return currentRouter
    })
})
/**
 * 格式化 后端 通过menu list组装树形结构
 *
 * @param menus
 * @param parent
 * @returns {*}
 * 明昌鹏
 * 2019-12-19
 */
export const menuTreeGenerator = (function treeGen(menus, parent) {
    const menu = {
        key: '',
        id: 0,
        path: '/',
        name: 'index',
        component: 'BasicLayout',
        meta: {
            title: '首页'
        },
        redirect: '/warehouse/warehouse-select',
        children: [],
        queryItem: {}
    }
    if (parent.length === 0) {
        const m = menus.find(a => (a.no === menu.path))
        menu.id = m.id
        parent.push(menu)
        const idx = menus.findIndex(a => (a.no === menu.path))
        menus.splice(idx, 1)
        if (menus.length > 0) {
            parent = menuTreeGenerator(menus, parent)
        }
    } else {
        parent = parent.sort(sortMenu)
        parent.map(item => {
            const ms = menus.filter(a => (a.parent !== null && a.parent !== undefined && a.parent.id === item.id))
            ms.map(m => {
                try {
                    const menu1 = new Menu()
                    menu1.key = m.no
                    menu1.id = m.id
                    menu1.path = m.url
                    menu1.name = m.no
                    menu1.ordinal = m.ordinal
                  const routeParam = m.parameter
                    const queryItem = {
                        queryParam: null,
                        business: null
                    }
                    if (typeof routeParam !== 'undefined') {
                        menu1.component = routeParam.component
                        menu1.hidden = routeParam.hidden
                        menu1.hideChildrenInMenu = routeParam.hideChildrenInMenu
                        menu1.meta = routeParam.meta
                        queryItem.business = typeof routeParam.business === 'undefined' ? null : routeParam.business
                    }
                    if (typeof m.query !== 'undefined' && m.query !== null) {
                        queryItem.queryParam = m.query
                    }
                    if ((queryItem.business !== 'undefined' && queryItem.business !== null) ||
                        (queryItem.queryParam !== 'undefined' && queryItem.queryParam !== null)
                    ) {
                        let params = Vue.ls.get(MENU_PARAM_LIST)
                        if (!params || Object.keys(params).length === 0) {
                            params = store.getters.menuParams || []
                        }
                        params = params.filter(item => item.key !== menu1.name)
                        params.push({ key: menu1.name, value: queryItem })
                        store.dispatch('SetMenuParams', params)
                        Vue.ls.set(MENU_PARAM_LIST, params)
                    }
                    menu1.queryItem = queryItem
                    item.children.push(menu1)
                } catch (e) {
                    return
                }
                menus.splice(menus.findIndex(a => (a.id === m.id)), 1)
            })
            if (menus.length > 0 && item.children.length > 0) {
                item.children = treeGen(menus, item.children)
            }
            return item
        })
    }
    return parent
})

function sortMenu(a, b) {
    return a.ordinal - b.ordinal//由低到高
    //return b.distance - a.distance;//由高到低
}

